import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { CustomCertificateService } from './services/custom-certificate.service';
import { I18nService } from 'i18n/i18n.service';
import { BzgModalService, BzgToastService, BzgToastType } from 'bz-genome-angular';
import { DeleteConfirmationComponent } from 'app/shared/components/delete-confirmation/delete-confirmation.component';
import { CryptoDataService } from 'app/core/services/crypto.data.service';
import { PasswordModalComponent } from './password-modal/password-modal';
import { ShowToastService } from 'app/shared/services/showToast.service';

@Component({
  selector: 'biz-custom-certificate',
  templateUrl: './custom-certificate.component.html',
  styleUrls: ['./custom-certificate.component.scss']
})
export class CustomCertificateComponent implements OnInit {
  
  customCertificate: any = {
    ClientCertificateName: '',
    ClientCertificateData: '',
    ClientCertificatePassword: '',
    EnableOdataValidation: false,
    EnableAsmxValidation: false,
    EnableWsSecurityValidation: false
  };

  @ViewChild('fileInput') file: ElementRef;
  
  constructor(private _certificateService: CustomCertificateService,
    private _i18nService: I18nService,
    private _toastService: BzgToastService,
    private _modalService: BzgModalService,
    private _showToastService: ShowToastService
  ) {
  }

  ngOnInit() {
    this.getCurrentCertificate();
  };

  getCurrentCertificate() {
    this._certificateService.getCurrentCertificate().subscribe(response => {
      if (response) {
        this.customCertificate.ClientCertificateData = response.ClientCertificateData;
        this.customCertificate.ClientCertificateName = response.ClientCertificateName;
        this.customCertificate.ClientCertificatePassword = response.ClientCertificatePassword;
        this.customCertificate.EnableAsmxValidation = response.EnableAsmxValidation;
        this.customCertificate.EnableOdataValidation = response.EnableOdataValidation;
        this.customCertificate.EnableWsSecurityValidation = response.EnableWsSecurityValidation;
      }
    });
  }

  changeEnableOptions(option: number) {
    if (option === 1)
      this.customCertificate.EnableOdataValidation = !this.customCertificate.EnableOdataValidation;
    else if (option === 2)
      this.customCertificate.EnableAsmxValidation = !this.customCertificate.EnableAsmxValidation;
    else if (option === 3)
      this.customCertificate.EnableWsSecurityValidation = !this.customCertificate.EnableWsSecurityValidation;
  }

  uploadCertificate() {
    this.file.nativeElement.click();
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      this.customCertificate.ClientCertificateName = file.name;

      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.customCertificate.ClientCertificateData = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  }

  saveCertificate() {
    if (this.customCertificate.ClientCertificateData) {
      const base64Prefix = this.customCertificate.ClientCertificateData.indexOf('base64,') + 'base64,'.length;
      if (base64Prefix !== -1)
        this.customCertificate.ClientCertificateData = this.customCertificate.ClientCertificateData.substring(base64Prefix);
    }
    this._certificateService.updateCustomCertificate(this.customCertificate).subscribe(response => {
      this.getCurrentCertificate();
      this._showToastService.showToast(this._i18nService.instant('GLOBAL.THE_OPERATION_WAS_SAVED_SUCCESSFULLY'), 'success');
    });
  }

  confirmDelete() {
    const title = this._i18nService.instant('CERTIFICATE.DELETE_TITLE');
    const message = this._i18nService.instant('CERTIFICATE.DELETE_MESSAGE');
    const modal = this._modalService.open(DeleteConfirmationComponent, {
      closeOnBackdropClick: false,
      closeOnRouterNavigation: true,
      data: { title, message, button: 'GLOBAL.DELETE' }
    });
    modal.afterClosed().subscribe((result) => {
      if (result === 'delete') {
        this.customCertificate.ClientCertificateName = '';
        this.customCertificate.ClientCertificateData = '';
        this.customCertificate.ClientCertificatePassword = '';
        this.customCertificate.EnableOdataValidation = false;
        this.customCertificate.EnableAsmxValidation = false;
        this.customCertificate.EnableWsSecurityValidation = false;
        this.saveCertificate();
      }
    });
  }

  showModalPassword() {
      const modal = this._modalService.open(PasswordModalComponent, {
        closeOnBackdropClick: false,
        closeOnRouterNavigation: true,
        data: {
          password: this.customCertificate.ClientCertificatePassword
        },
        maxWidth: 'none',
        maxHeight: '50%',
        width: '500px',
        
      });
  
      modal.afterClosed().subscribe(password => {
        this.customCertificate.ClientCertificatePassword = password;
      });
  }

}
